module.exports = __webpack_public_path__ + "img/medal.3062cb90.png";